import { render, staticRenderFns } from "./ScoreQuestionType.vue?vue&type=template&id=00a79a6a&scoped=true"
import script from "./ScoreQuestionType.vue?vue&type=script&lang=js"
export * from "./ScoreQuestionType.vue?vue&type=script&lang=js"
import style0 from "./ScoreQuestionType.vue?vue&type=style&index=0&id=00a79a6a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a79a6a",
  null
  
)

export default component.exports